import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { playPop } from '../sounds';
import RegistryModal from './RegistryModal';
import './Evite.css';

function Evite() {
  const navigate = useNavigate();
  const [showRegistry, setShowRegistry] = useState(false);

  return (
    <div className="evite-container">
      <div className="evite-content">
        <div className="shop-awning">
          <div className="awning-stripes"></div>
          <div className="awning-scallop"></div>
        </div>
        <img
          src="/invitation.png"
          alt="Baby Shower Invitation"
          className="invitation-image"
        />
        
        {/* <div className="event-summary">
          <h2>🎀 You're Invited! 🎀</h2>
          <div className="event-details">
            <p><strong>When:</strong> March 14, 2026 at 2:00 PM</p>
            <p><strong>Where:</strong> 13954 Hamlin St., Valley Glen, CA 91401</p>
          </div>
        </div> */}
        <div className="checkout-button-container">
          <button
            className="checkout-button"
            onClick={() => { playPop(); navigate('/rsvp'); }}
          >
            <span className="button-icon">🗓️</span>
            RSVP
            <span className="button-arrow">→</span>
          </button>

          <button
            className="checkout-button"
            onClick={() => setShowRegistry(true)}
          >
            <span className="button-icon">🎁</span>
            View Registry
            <span className="button-arrow">→</span>
          </button>
        </div>

        {/* <div className="evite-footer">
          <p>Can't wait to celebrate with you! 💕</p>
        </div> */}
      </div>

      {showRegistry && <RegistryModal onClose={() => setShowRegistry(false)} />}
    </div>
  );
}

export default Evite;
